import customerQuery, { CustomerQuery } from '@/customer/models/CustomerQuery';
import { ScheduleEventParam } from '@/rule/models/ScheduleEventParam';
import { ScheduleDelay } from '@/rule/models/ScheduleDelay';
import CustomerProp from '@/customer/models/CustomerProp';

export interface ScheduleRuleContext {
  EventTriggered: EventTriggered;
  Periodic: Periodic;
  TimeFieldBased: TimeFieldBased;
}

export interface EventTriggered {
  eventType?: number;
  delay?: ScheduleDelay;
  param?: ScheduleEventParam;
}

export interface TimeFieldBased {
  prop?: CustomerProp;
  field?: string;
  triggerDayOffset: number;
  triggerTime?: string;
}

export interface Periodic {
  query: CustomerQuery;
  freq?: PeriodicFreq;
}

export function createEventTriggered(): EventTriggered {
  return {
    eventType: undefined,
    delay: undefined,
    param: undefined,
  };
}

export enum ScheduleEventDelayType {
  RightNow = 0,
  InMinutes = 1,
  InHours = 2,
  InDays = 3,
}

// tslint:disable no-empty-interface
export interface PeriodicFreq {
  Daily?: PeriodicDaily;
  Weekly?: PeriodicWeekly;
  Monthly?: PeriodicMonthly;
}
export interface PeriodicDaily {
  time: string;
}
export interface PeriodicWeekly {
  days: number[];
  time: string;
}
export interface PeriodicMonthly {
  days: number[];
  time: string;
}

export function createPeriodic(): Periodic {
  return {
    query: customerQuery,
    freq: undefined,
  };
}

export function createTimeFieldBased(): TimeFieldBased {
  return {
    field: undefined,
    triggerDayOffset: 0,
    triggerTime: undefined,
  };
}
